import React from 'react';
import { FaTint, FaBolt, FaLeaf, FaTachometerAlt, FaHandsWash, FaChartBar } from 'react-icons/fa';
import './TechnicalAdvantages.css';
import { Link } from 'react-router-dom';

const advantages = [
 {
  icon: <FaTint size={36} color="#1976d2" />,
  title: 'Water Efficiency',
  desc: <>Our <Link to="/" className="link-text">car wash near me</Link> solutions are designed for superior water efficiency, utilizing advanced high-pressure nozzles and precision delivery systems. These technologies reduce water consumption by 60–70% compared to manual washing, making them both environmentally responsible and cost-effective.</>
},
{
  icon: <FaBolt size={36} color="#43a047" />,
  title: 'Energy Efficient Motors',
  desc: 'Our automatic car wash systems are equipped with energy-efficient motors and pumps that minimize power usage while maintaining high performance. This ensures sustainable operations and supports eco-conscious car wash practices.'
},
{
  icon: <FaLeaf size={36} color="#388e3c" />,
  title: 'Chemical Management',
  desc: 'We use premium car spa products in Bangalore with eco-friendly, biodegradable formulations and automated dosing systems. This minimizes chemical waste, reduces environmental impact, and supports efficient water recycling processes.'
},
{
  icon: <FaTachometerAlt size={36} color="#fbc02d" />,
  title: 'Consistency and Speed',
  desc: 'Our automated systems deliver consistent cleaning quality with every cycle. Each wash is completed in under 10 minutes, allowing high throughput and efficient service compared to traditional methods.'
},
{
  icon: <FaHandsWash size={36} color="#0288d1" />,
  title: 'Touchless Technology',
  desc: 'Using high-pressure water jets and advanced detergents, our touchless systems clean vehicles without physical contact. This reduces the risk of scratches and ensures a safer wash for all vehicle types.'
},
{
  icon: <FaChartBar size={36} color="#8e24aa" />,
  title: 'Data-Driven Optimization',
  desc: 'Our systems use sensors and IoT-based monitoring to track water usage, energy consumption, and chemical levels. Combined with auto wash products near me standards, this enables continuous performance optimization and efficiency improvements.'
}
];

const TechnicalAdvantages = () => {
  return (
    <section className="technical-advantages-section creative-ui container">
      <h2 className="ta-title">Technical Advantages</h2>
      <div className="ta-grid">
        {advantages.map((adv, idx) => (
          <div className="ta-card" key={adv.title}>
            <div className="ta-card-icon">{adv.icon}</div>
            <div className="ta-card-content">
              <div className="ta-card-title">{adv.title}</div>
              <div className="ta-card-desc">{adv.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechnicalAdvantages; 